import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { getOrigin } from '../utils';

const Footer = () => {
  const { t } = useTranslation();
  const originUrl = getOrigin();

  return (
    <Wrapper>
      {t('footer.description1')}
      <br />
      {t('footer.description2')} {t('footer.description3')}
      <a target="_blank" href={`${originUrl}/policy/privacy`}>
        [{t('footer.view')}]
      </a>{' '}
      {t('footer.description4')} {t('footer.description5')}
      <a target="_blank" href={`${originUrl}/policy/terms`}>
        [{t('footer.view')}]
      </a>{' '}
      {t('footer.description6')}
      <a
        target="_blank"
        href="https://www.ftc.go.kr/bizCommPop.do?wrkr_no=2628702816"
      >
        [{t('footer.verify')}]
      </a>
    </Wrapper>
  );
};

export default Footer;

const Wrapper = styled.footer`
  width: 100%;
  text-align: center;
  font-size: 9px;
  color: #99a1b5;
  white-space: pre-wrap;
  padding: 20px;
  z-index: 10;

  a {
    text-decoration: underline;
  }
`;
